interface EnvConfig {
    VITE_GOOGLE_CLIENT_ID?: string
    VITE_API_BASE_URL?: string
    VITE_STARTER_PACK_BASE_URL?: string
    VITE_PROCESS_HUB_BASE_URL?: string
}

class Settings {
    environment: EnvConfig = {}
    private requiredEnvVars: (keyof EnvConfig)[] = [
        'VITE_GOOGLE_CLIENT_ID',
        'VITE_API_BASE_URL',
        'VITE_STARTER_PACK_BASE_URL',
        'VITE_PROCESS_HUB_BASE_URL',
    ];

    constructor() {
        this.environment.VITE_GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID
        this.environment.VITE_API_BASE_URL = import.meta.env.VITE_API_BASE_URL
        this.environment.VITE_STARTER_PACK_BASE_URL = import.meta.env.VITE_STARTER_PACK_BASE_URL
        this.environment.VITE_PROCESS_HUB_BASE_URL = import.meta.env.VITE_PROCESS_HUB_BASE_URL
        this.validateEnvVariables()
    }

    private validateEnvVariables(): void {
        this.requiredEnvVars.forEach((key) => {
            if (!this.environment[key]) {
                console.error(`Missing environment variable: ${key}`);
            }
        });
    }
}

export const settings = new Settings()
